import React from 'react';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import SlideshowIcon from '@material-ui/icons/Slideshow';
import ListAltIcon from '@material-ui/icons/ListAlt';
import MapIcon from '@material-ui/icons/Map';
import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';


export const ROLES_LIST = [
{name:"online-asset-manager.company-settings",title:"Pengaturan Perusahaan",icon:MenuBookIcon},
{name:"online-asset-manager.branch-settings",title:"Pengaturan Cabang",icon:SlideshowIcon},
{name:"online-asset-manager.domain-settings",title:"Pengaturan Domain",icon:ListAltIcon},
{name:"online-asset-manager.company-billings",title:"Billings",icon:MapIcon},

{name:"online-asset-manager.secure.users",title:"Daftar User",icon:DeveloperBoardIcon},
{name:"online-asset-manager.secure.tokens",title:"Daftar Token",icon:DeveloperBoardIcon},
{name:"online-asset-manager.secure.mobile-apps",title:"Daftar Mobile App",icon:DeveloperBoardIcon},
{name:"online-asset-manager.secure.machines",title:"Daftar IoT",icon:DeveloperBoardIcon},
{name:"online-asset-manager.secure.companies",title:"Daftar Company",icon:DeveloperBoardIcon},
{name:"online-asset-manager.secure.billings",title:"Daftar Billing",icon:DeveloperBoardIcon},
{name:"online-asset-manager.secure.domains",title:"Daftar Domain",icon:DeveloperBoardIcon},

{name:"online-asset-manager.share",title:"",icon:null},

]

export const getTitleByAccessName=(name)=>{
for(var i=0;i<ROLES_LIST.length;i++){
    if(ROLES_LIST[i].name===name){
    return ROLES_LIST[i].title
    }
}
return "unknown"
}
export const getIconByAccessName=(name)=>{
for(var i=0;i<ROLES_LIST.length;i++){
    if(ROLES_LIST[i].name===name){
    return ROLES_LIST[i].icon
    }
}
return "UnknownIcon"
}
  


export const ADMIN = 'admin';
export const generalAccesses=["owner","billing","cashbox","supplier","reseller","customer","productCategory","product","employee","sell","sellReturn","buy","buyReturn","report"]